export const toastMessages = {
	showLinkCopyToast: 'Link copied to clipboard',
	showOverlayErrorToast: 'Failed to load overlay',
	failedToCreateLink: 'Failed to create link'
};
